import React from 'react';
import {useTranslation} from 'react-i18next';
import {Alert} from '@taopix/taopix-design-system';
import {LayoutSelector} from '../../../Selectors';
import {useSelector} from 'react-redux';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../../Context/UserInterface/UserInterfaceActionTypes';
import {DialogStatus} from '../../../Enums';

type PageCountChangeNotificationProps = {
  open: boolean;
};

const PageCountChangeNotification = ({open}: PageCountChangeNotificationProps) => {
  const {t} = useTranslation();
  const productLayout = useSelector(LayoutSelector);
  const ui = useUiState();

  const closeDialog = () => {
    ui.dispatch(UserInterfaceActions.setFlags({pageCountChanged: false}));
    ui.dispatch(
      UserInterfaceActions.setDialogStatus({pageCountChangeNotification: DialogStatus.Seen})
    );
  };

  const getErrorMessage = () => {
    return t('str_MessageMainCheckPageCountError').replace(
      '^0',
      productLayout.pageinsertcount.toString()
    );
  };

  return (
    <Alert
      id={'page-count-changed-notification'}
      open={open}
      type={'warning'}
      message={getErrorMessage()}
      onClose={closeDialog}
    />
  );
};

export default PageCountChangeNotification;
